export default __webpack_public_path__ + "static/media/cookie-dog.931afe67.jpg";